import {
  Slide,
  Button,
  Link,
  VStack,
  HStack,
  Stack,
  Text,
  AspectRatio,
  UseDisclosureReturn,
  Box,
  Flex,
  Portal,
} from '@chakra-ui/react'
import Image from 'next/image'

import {
  logCTAEvent,
  logPreviewEvent,
} from '@/features/Courses/helpers/gtmEvent'

import { Course } from '@/features/Courses/types'

interface Props {
  course: Course
  disclosure: UseDisclosureReturn
}

function TitleDrawer({ course, disclosure }: Props): React.ReactElement {
  const { isOpen } = disclosure
  return (
    <Portal>
      <Slide in={isOpen} direction="bottom">
        <Flex
          sx={{
            boxShadow: '0px -4px 12px rgba(117, 117, 117, 0.25)',
            py: 4,
            bg: 'white',
            alignItems: 'stretch',
          }}
        >
          <Box sx={{ h: 'full' }} layerStyle="landingContainer">
            <HStack
              spacing={{
                base: 0,
                sm: 4,
              }}
              sx={{ alignItems: 'stretch' }}
            >
              <AspectRatio
                ratio={1280 / 720}
                sx={{
                  w: '256px',
                  flex: '0 0 256px',
                  borderRadius: '8px',
                  alignSelf: 'flex-start',
                  display: {
                    base: 'none',
                    sm: 'block',
                  },
                  '& img': {
                    borderRadius: '8px',
                  },
                }}
              >
                <Image
                  src={course.image}
                  alt={course.title}
                  layout="fill"
                  objectFit="cover"
                />
              </AspectRatio>
              <VStack
                spacing="4"
                sx={{
                  alignItems: 'stretch',
                  flex: '1 1 auto',
                }}
              >
                <HStack
                  spacing="4"
                  sx={{
                    alignItems: 'stretch',
                    justifyContent: 'space-between',
                  }}
                >
                  <VStack
                    spacing="1"
                    sx={{
                      alignItems: 'stretch',
                    }}
                  >
                    <Text
                      sx={{
                        fontSize: {
                          base: 'lg',
                          sm: '2xl',
                        },
                        color: 'primary.800',
                        fontWeight: 'bold',
                      }}
                    >
                      {course.title}
                    </Text>
                    <Text
                      sx={{
                        fontSize: 'sm',
                        fontWeight: 'light',
                        color: 'gray.700',
                        display: {
                          base: 'none',
                          sm: 'block',
                        },
                      }}
                    >
                      {course.subtitle}
                    </Text>
                  </VStack>
                  <Text
                    sx={{
                      mt: 2,
                      fontSize: {
                        base: 'xl',
                        sm: '2xl',
                      },
                      fontWeight: 'bold',
                      color: 'primary.500',
                      textAlign: 'right',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {course.price}
                  </Text>
                </HStack>
                <Stack
                  direction={{
                    base: 'column',
                    sm: 'row',
                  }}
                  sx={{
                    alignItems: 'stretch',
                    justifyContent: 'space-between',
                  }}
                >
                  <Button
                    as={Link}
                    isExternal
                    href={course.coursePageLink}
                    onClick={() => {
                      logCTAEvent(course.slug)
                    }}
                    size="lg"
                    sx={{
                      mt: { sm: 'auto !important' },
                      textDecoration: 'none !important',
                      w: 'full',
                      h: '48px',
                      fontSize: 'xl',
                    }}
                  >
                    ชำระเงินเพื่อเริ่มเรียน
                  </Button>
                  {course.previewLink && (
                    <Button
                      as={Link}
                      isExternal
                      href={course.previewLink}
                      variant="outline"
                      size="lg"
                      sx={{
                        textDecoration: 'none !important',
                        w: 'full',
                        h: '48px',
                        fontSize: 'xl',
                      }}
                      onClick={() => {
                        logPreviewEvent(course.slug)
                      }}
                    >
                      ทดลองเรียนฟรี !
                    </Button>
                  )}
                </Stack>
              </VStack>
            </HStack>
          </Box>
        </Flex>
      </Slide>
    </Portal>
  )
}

export default TitleDrawer
